import { render, staticRenderFns } from "./AdminTesoreria.vue?vue&type=template&id=7b645554&"
import script from "./AdminTesoreria.vue?vue&type=script&lang=js&"
export * from "./AdminTesoreria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports